import type {
  ELineChannelStatus,
  ELineWebhookStatus,
  EOrganizationPlan,
  EPausedBy,
} from './enum'

/**
 * BAN状況ダッシュボードの件数。
 * autoPaused = PAUSED かつ pausedBy=HEALTH_CHECK（BAN/凍結の疑い）
 * manualPaused = PAUSED かつ pausedBy=MANUAL（人手停止・Webhook未有効）
 * notAllocatable = 稼働中(ACTIVE/FULL)だが払い出し条件を満たさない
 */
export type TBanStatusCounts = {
  total: number
  active: number
  full: number
  autoPaused: number
  manualPaused: number
  unlinked: number
  webhookInvalid: number
  allocatable: number
  notAllocatable: number
  /** 互換性のため残すアカウント単位の延べ件数。ユーザー数の表示には使わない。 */
  activeFriends: number
  pausedFriends: number
  /** ユーザー一覧の絞り込み前の総数。全体集計では組織別人数の合計。旧APIでは欠けるため0と区別する。 */
  totalUsers?: number | null
  operatingUsers?: number | null
  pausedUsers?: number | null
  pausedOnlyUsers?: number | null
  /** ユーザー一覧でブロックだけに絞り込んだ件数。 */
  blockedUsers?: number | null
}

export type TBanStatusSummary = TBanStatusCounts & {
  totalOrganizations: number
  organizationsWithoutAllocatableChannel: number
}

export type TBanStatusOrganization = TBanStatusCounts & {
  organizationId: number
  organizationName: string
  plan: EOrganizationPlan
}

export type TBanStatusResponse = {
  summary: TBanStatusSummary
  organizations: TBanStatusOrganization[]
}

/** 一覧の絞り込み分類。条件は重複し得るためサーバ側で判定する。 */
export const BAN_STATUS_CHANNEL_CATEGORIES = [
  'autoPaused',
  'manualPaused',
  'unlinked',
  'webhookInvalid',
  'notAllocatable',
] as const

export type TBanStatusChannelCategory =
  (typeof BAN_STATUS_CHANNEL_CATEGORIES)[number]

export type TBanStatusChannel = {
  lineChannelId: number
  organizationId: number
  organizationName: string
  basicId: string
  memo: string | null
  status: ELineChannelStatus
  // status=PAUSED のときだけ値が入る
  pausedBy: EPausedBy | null
  webhookStatus: ELineWebhookStatus
  activeFriends: number
  friendLimit: number | null
  unlinkedAt: string | null
  updatedAt: string
}

export type TListBanStatusChannelsRequest = {
  organizationId?: number
  category?: TBanStatusChannelCategory
  keyword?: string
  currentPage?: number
  pageSize?: number
}

export type TBanStatusChannelListResponse = {
  items: TBanStatusChannel[]
  total: number
  currentPage: number
  totalPage: number
}
